export default __webpack_public_path__ + "static/media/quickcam_invite.bdbb6a5e.svg";